import { useState, useEffect } from 'react';
import { getNews, createNews, updateNews, deleteNews } from '../api'; // ✅ import your API functions



export default function NewsManager() {
  const [news, setNews] = useState([]);
  const [form, setForm] = useState({
    topic: '',
    shortDescription: '',
    longDescription: '',
    date: '',
    imageUrl: '', 
  });
const [editingId, setEditingId] = useState(null); // ✅ track which item is being edited
const [showModal, setShowModal] = useState(false);

  const fetchNews = async () => {
    try {
      const res = await getNews();
      setNews(res.data);
    } catch {
      console.error('Failed to fetch news');
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

 const handleEdit = (item) => {
  setForm({
    topic: item.topic,
    shortDescription: item.shortDescription,
    longDescription: item.longDescription,
    date: item.date.split('T')[0],
    imageUrl: item.imageUrl,
  });
  setEditingId(item.id);
  setShowModal(true); // ✅ open modal
};


const handleDelete = async (id) => {
  try {
    await deleteNews(id);
    fetchNews();
  } catch {
    console.error('Failed to delete news');
  }
};

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    if (editingId) {
      await updateNews(editingId, form);
      setShowModal(false); // ✅ close modal after update
    } else {
      await createNews(form);
    }
    setForm({ topic: '', shortDescription: '', longDescription: '', date: '', imageUrl: '' });
    setEditingId(null);
    fetchNews();
  } catch {
    console.error('Failed to save news');
  }
};


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-black dark:text-blue-500">📰 News Manager</h1>

 {showModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded shadow-lg w-full max-w-xl space-y-4 dark:bg-gray-800">
      <h2 className="text-xl font-bold text-black dark:text-green-500">✏️ Edit News</h2>
      <form onSubmit={handleSubmit} className="space-y-4 dark:bg-gray-800">
        <input name="topic" value={form.topic} onChange={handleChange} placeholder="Topic" className="w-full p-2 border dark:text-black" />
        <input name="shortDescription" value={form.shortDescription} onChange={handleChange} placeholder="Short Description" className="w-full p-2 border dark:text-black" />
        <input name="imageUrl" value={form.imageUrl} onChange={handleChange} placeholder="Image URL" className="w-full p-2 border dark:text-black" />
        <input name="date" type="date" value={form.date} onChange={handleChange} className="w-full p-2 border dark:text-black" />
        <textarea name="longDescription" value={form.longDescription} onChange={handleChange} placeholder="Long Description" className="w-full p-2 border h-32 dark:text-black" />
        <div className="flex space-x-4">
          <button type="submit" className="bg-green-500 text-white px-4 py-2 rounded dark:bg-green-500 hover:dark:bg-green-600 text-white">Update</button>
          <button type="button" onClick={() => { setShowModal(false); setEditingId(null); setForm({ topic: '', shortDescription: '', longDescription: '', date: '', imageUrl: '' }); }} className="bg-gray-300 text-black px-4 py-2 rounded">Cancel</button>
        </div>
      </form>
    </div>
  </div>
)}

      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded shadow dark:bg-gray-800">
        <input name="topic" value={form.topic} onChange={handleChange} placeholder="Topic" className="w-full p-2 border dark:text-black" />
        <input name="shortDescription" value={form.shortDescription} onChange={handleChange} placeholder="Short Description" className="w-full p-2 border dark:text-black" />
        <input
  name="imageUrl"
  value={form.imageUrl}
  onChange={handleChange}
  placeholder="Image URL"
  className="w-full p-2 border dark:text-black"
/>
        <input name="date" type="date" value={form.date} onChange={handleChange} className="w-full p-2 border dark:text-black" />
        <textarea name="longDescription" value={form.longDescription} onChange={handleChange} placeholder="Long Description" className="w-full p-2 border h-32 dark:text-black" />
        <button type="submit" className="bg-green-500 dark:bg-green-500 hover:dark:bg-blue-600 text-white text-white px-4 py-2 rounded">Add News</button>
      </form>

      <div className="grid gap-4">
        {news.map(item => (
  <div key={item.id} className="bg-white p-4 rounded shadow dark:bg-gray-800">
    <img
  src={item.imageUrl || 'https://via.placeholder.com/400x200?text=No+Image'}
  alt={item.topic}
  className="w-full h-48 object-cover rounded mb-2"
/>
    <h2 className="text-xl font-semibold text-black dark:text-blue-500">{item.topic}</h2>
    <p className="text-sm text-gray-500 dark:text-gray-300">{new Date(item.date).toLocaleDateString()}</p>
    <p className="mt-2 text-gray-700 dark:text-gray-300">{item.shortDescription}</p>
    <details className="mt-2">
      <summary className="text-green-500 cursor-pointer dark:text-green-500">Read more</summary>
      <p className="mt-2">{item.longDescription}</p>
    </details>
    <div className="flex justify-end space-x-4 mt-2">
      <button onClick={() => handleEdit(item)} title="Edit">✏️</button>
      <button onClick={() => handleDelete(item.id)} title="Delete">❌</button>
    </div>
  </div>
))}
      </div>
    </div>
   
  );
}